import { render, staticRenderFns } from "./battleNetUserUpdate.vue?vue&type=template&id=3143c38c&scoped=true"
import script from "./battleNetUserUpdate.vue?vue&type=script&lang=js"
export * from "./battleNetUserUpdate.vue?vue&type=script&lang=js"
import style0 from "./battleNetUserUpdate.vue?vue&type=style&index=0&id=3143c38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143c38c",
  null
  
)

export default component.exports